module.exports = __webpack_public_path__ + "static/media/yer.static.2738a007.svg";